export const entryChannels = [
  {
    name: "主站入口",
    desc: "官方直连线路，首屏加载最快，推荐日常访问。",
    tag: "推荐",
    status: "畅通",
    address: "heiliao-direct.cc",
    latency: "0.4s",
    heat: 98,
  },
  {
    name: "备用线路 A",
    desc: "主站拥堵时自动兜底，节点位于东亚。",
    tag: "备用",
    status: "畅通",
    address: "heiliao-bk-a.cc",
    latency: "0.7s",
    heat: 86,
  },
  {
    name: "镜像地址",
    desc: "多节点镜像同步，长期可用不轻易失效。",
    tag: "镜像",
    status: "稳定",
    address: "heiliao-mirror.cc",
    latency: "0.6s",
    heat: 74,
  },
  {
    name: "移动端链接",
    desc: "适配手机浏览器，免安装直接浏览爆料。",
    tag: "移动端",
    status: "畅通",
    address: "m.heiliao-now.cc",
    latency: "0.5s",
    heat: 91,
  },
  {
    name: "客户端下载",
    desc: "安卓与 iOS 安装包，当前正在做安全校验。",
    tag: "客户端",
    status: "校验中",
    address: "app.heiliao-now.cc",
    latency: "—",
    heat: 63,
  },
  {
    name: "地址通知频道",
    desc: "网址变动第一时间推送，建议先订阅再收藏。",
    tag: "订阅",
    status: "畅通",
    address: "@heiliao_update",
    latency: "实时",
    heat: 80,
  },
];

export const tickerItems = [
  "主站入口今日完成一次节点切换，访问速度提升约 30%",
  "备用线路 A 已恢复，此前短暂拥堵的情况已解决",
  "镜像地址新增东京节点，晚高峰访问更稳",
  "移动端链接完成适配更新，横屏浏览不再错位",
  "客户端安装包进入校验阶段，预计稍后放出下载",
  "地址通知频道订阅数突破新高，建议同步关注",
  "首页新增分类索引，找合集比过去快很多",
];

export const collectionTabs = [
  { key: "latest", label: "最新更新" },
  { key: "hot", label: "热度最高" },
  { key: "archive", label: "归档合集" },
];

export const collectionItems = [
  {
    id: "c-01",
    title: "本周热议时间线：多平台爆料整理",
    desc: "把分散在各个渠道的讨论按时间顺序梳理成一条线，从最早的路透到后续回应，重要节点一目了然，适合想快速补课的人。",
    tag: "深度合集",
    readCount: "12.4万",
    updated: "2 小时前",
    scope: "hot",
    size: "large",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20texture%20with%20layered%20paper%20cut%20shapes%20in%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20soft%20diffused%20studio%20lighting%2C%20grainy%20matte%20finish%2C%20calm%20neutral%20background%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=1200&height=800&seq=hl-collection-main-01&orientation=landscape",
  },
  {
    id: "c-02",
    title: "合约纠纷完整脉络梳理",
    desc: "从合作官宣到解约声明的关键节点。",
    tag: "商业动向",
    readCount: "8.6万",
    updated: "4 小时前",
    scope: "hot",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20paper%20texture%20with%20soft%20folded%20layers%20in%20warm%20amber%20and%20beige%20tones%2C%20soft%20diffused%20lighting%2C%20matte%20grainy%20surface%2C%20clean%20neutral%20background%2C%20editorial%20still%20life%20aesthetic%2C%20no%20text&width=800&height=800&seq=hl-collection-s-02&orientation=squarish",
  },
  {
    id: "c-03",
    title: "新生代口碑反转记录",
    desc: "数据与讨论同时回顾，口碑起伏全记录。",
    tag: "人物观察",
    readCount: "6.1万",
    updated: "6 小时前",
    scope: "latest",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20shapes%20in%20warm%20rust%20and%20sand%20colors%2C%20layered%20cut%20paper%20feel%2C%20gentle%20studio%20lighting%2C%20matte%20textured%20finish%2C%20minimal%20neutral%20backdrop%2C%20design%20magazine%20still%2C%20no%20text&width=800&height=800&seq=hl-collection-s-03&orientation=squarish",
  },
  {
    id: "c-04",
    title: "品牌代言变动速览",
    desc: "近一个月内的品牌动作一次性对齐。",
    tag: "品牌商战",
    readCount: "5.3万",
    updated: "9 小时前",
    scope: "latest",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20geometric%20blocks%20in%20muted%20orange%20cream%20and%20clay%20tones%2C%20soft%20shadowless%20studio%20lighting%2C%20paper%20matte%20grain%20texture%2C%20simple%20clean%20background%2C%20modern%20editorial%20composition%2C%20no%20text&width=800&height=800&seq=hl-collection-s-04&orientation=squarish",
  },
  {
    id: "c-05",
    title: "综艺剪辑争议合集",
    desc: "按播出顺序整理的争议片段索引。",
    tag: "综艺瓜田",
    readCount: "4.8万",
    updated: "13 小时前",
    scope: "hot",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20layered%20ribbon%20shapes%20in%20warm%20amber%20and%20deep%20clay%20tones%2C%20soft%20even%20lighting%2C%20matte%20paper%20texture%2C%20minimal%20neutral%20backdrop%2C%20calm%20editorial%20still%20life%2C%20no%20text&width=800&height=800&seq=hl-collection-s-05&orientation=squarish",
  },
  {
    id: "c-06",
    title: "片场路透时间线归档",
    desc: "早期路透到正式杀青的完整索引。",
    tag: "归档",
    readCount: "3.9万",
    updated: "1 天前",
    scope: "archive",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stacked%20archival%20cards%20in%20warm%20beige%20and%20soft%20rust%20tones%2C%20soft%20diffused%20studio%20light%2C%20matte%20grainy%20surface%2C%20plain%20light%20neutral%20background%2C%20minimal%20design%20still%20life%2C%20no%20text&width=800&height=800&seq=hl-collection-s-06&orientation=squarish",
  },
  {
    id: "c-07",
    title: "赛事场外话题归档",
    desc: "按赛程整理的场外讨论索引。",
    tag: "归档",
    readCount: "3.1万",
    updated: "2 天前",
    scope: "archive",
    size: "small",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20circular%20shapes%20overlapping%20in%20warm%20ochre%20and%20cream%20palette%2C%20soft%20even%20studio%20lighting%2C%20matte%20textured%20paper%20surface%2C%20clean%20neutral%20background%2C%20minimal%20editorial%20graphic%2C%20no%20text&width=800&height=800&seq=hl-collection-s-07&orientation=squarish",
  },
];

export const quickBites = [
  {
    tag: "娱乐八卦",
    title: "某剧集番位讨论再起，官方暂未回应",
    source: "汇总编辑",
    time: "18 分钟前",
    hot: true,
  },
  {
    tag: "网红动态",
    title: "直播间口误片段被二次剪辑，粉丝要求还原语境",
    source: "吃瓜速览",
    time: "42 分钟前",
    hot: true,
  },
  {
    tag: "品牌商战",
    title: "两家同品类品牌同日官宣新代言人，话题撞车",
    source: "商战观察",
    time: "1 小时前",
    hot: false,
  },
  {
    tag: "综艺瓜田",
    title: "新一期剪辑节奏被吐槽，弹幕集中讨论镜头分配",
    source: "综艺速报",
    time: "2 小时前",
    hot: false,
  },
  {
    tag: "剧集速报",
    title: "开播三日口碑两极，评分曲线出现明显拐点",
    source: "剧集档案",
    time: "3 小时前",
    hot: false,
  },
  {
    tag: "数码圈",
    title: "发布会参数对比图流出，评论区质疑标称口径",
    source: "数码花边",
    time: "4 小时前",
    hot: false,
  },
  {
    tag: "财经花边",
    title: "高管社交账号发言被放大解读，公司股价小幅波动",
    source: "财经侧写",
    time: "5 小时前",
    hot: false,
  },
  {
    tag: "海外吃瓜",
    title: "海外活动红毯造型对比，造型团队差异成焦点",
    source: "海外速览",
    time: "7 小时前",
    hot: false,
  },
];

export const categoryIndex = [
  { name: "娱乐八卦", count: 1284 },
  { name: "网红动态", count: 962 },
  { name: "品牌商战", count: 731 },
  { name: "剧集速报", count: 645 },
  { name: "综艺瓜田", count: 588 },
  { name: "赛事场外", count: 512 },
  { name: "财经花边", count: 436 },
  { name: "数码圈", count: 401 },
  { name: "汽车圈", count: 357 },
  { name: "游戏圈", count: 312 },
  { name: "海外吃瓜", count: 288 },
  { name: "榜单档案", count: 246 },
];

export const accessNotices = [
  {
    icon: "ri-links-line",
    title: "优先收藏多个入口",
    desc: "建议同时保存主站入口与备用线路，任一地址临时波动时可立刻切换，不影响浏览爆料内容。",
  },
  {
    icon: "ri-refresh-line",
    title: "地址变动以通知为准",
    desc: "网址与链接会不定期微调，最新可用的地址只会通过订阅频道发布，请认准官方渠道发布的链接。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不点击来历不明链接",
    desc: "首页展示的入口均经过校验，遇到名称相似但地址不同的页面请提高警惕，避免误入仿冒站点。",
  },
];

export const faqItems = [
  {
    q: "黑料平台入口打不开怎么办？",
    a: "先尝试本页的备用线路 A 或镜像地址，这两条线路与主站入口内容一致。若全部无法访问，多半是本地网络波动，切换网络后重试通常即可恢复。",
  },
  {
    q: "最新的黑料平台网址和地址在哪里看？",
    a: "首页上方的入口索引会持续更新，标注为“畅通”或“稳定”的地址为当前可用链接。建议同时订阅地址通知频道，网址变动时会第一时间推送。",
  },
  {
    q: "手机上可以直接访问吗？",
    a: "可以。移动端链接针对手机浏览器做了适配，免安装即可浏览。若希望更稳定的体验，也可以等客户端安装包完成校验后下载使用。",
  },
  {
    q: "为什么会有多个不同的链接？",
    a: "同一站点通常会准备多条线路用于分流和兜底：主站入口速度最快，备用线路在主站拥堵时接力，镜像地址则用于长期稳定访问，彼此内容同步。",
  },
  {
    q: "首页内容多久更新一次？",
    a: "入口索引与速览内容每日多次更新，合集类内容按热度与时间归档整理，通常会在一天内完成新一轮的更替。",
  },
];